import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import callApi from "../../../Apis/callApi";
import Tags from "../../../Components/Tags";
import ContentBody from "../../../Components/Content/ContentBody";
import ContentHead from "../../../Components/Content/ContentHead";
import InputField from "../../../Components/InputField";
import Content from "../../../Components/Content/Content";
import styles from "../../../Styles/inputField.module.css";
import UploadImage from "../../../Utils/UploadImage";
import { getExtendedFileName } from "../../../Utils/ImageHelper";
import Loading from "../../../Components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

// interface CreatePartnerProps {}

const CreatePartner = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const [isImageChanged, setIsImageChanged] = useState(false);
  const [isLogoChanged, setIsLogoChanged] = useState(false);
  const [tags, setTags] = useState<any>([]);
  const [image, setImage]: any = useState(null);
  const [image2, setImage2]: any = useState(null);
  const [partnerBrochure, setPartnerBrochure] = useState("");
  const [values, setValues] = useState<any>({
    partnerName: "",
    partnerCity: "",
    partnerCountry: "",
    description: "",
    solution: "",
    logoUrl: "",
    imageOne: "",
    priority: "",
  });

  const {
    partnerName,
    partnerCity,
    partnerCountry,
    description,
    solution,
    // logoUrl,
    // imageOne,
    // priority,
  } = values;

  useEffect(() => {
    if (id) {
      getData();
    }
  }, []);

  const getData = () => {
    callApi({
      url: "getPartnerById/" + id,
      method: "get",
      type: "partner",
    })
      .then((res) => {
        // console.log('update Partner api called',res);
        setValues({
          partnerName: res.data.data.partnerName,
          partnerCity: res.data.data.partnerCity,
          partnerCountry: res.data.data.partnerCountry,
          description: res.data.data.description,
          // solution: res.data.data.solution,
          // logoUrl: "",
          // imageOne: "",
        });
        setImage(res.data.data.logoUrl);
        setImage2(res.data.data.imageOne);
        setTags(res.data.data.solution);
        setPartnerBrochure(res.data.data?.partnerBrochure);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Something went wrong while fetching data!");
      });
  };

  const handleimage = (e: any) => {
    const file = e.target.files[0];
    setImage(file);
  };

  const handleimage2 = (e: any) => {
    const file = e.target.files[0];
    // console.log(file);

    setImage2(file);
  };

  const onChange = (e: any) => {
    let name = e.target.name;

    let value = e.target.value;
    setValues({ ...values, [name]: value });
  };

  const handleClick = (e: any) => {
    e.preventDefault();
    if (e.target.name === "discard") {
      setValues({
        partnerName: "",
        partnerCity: "",
        partnerCountry: "",
        description: "",
        solution: "",
        logoUrl: "",
        imageOne: "",
        priority: "",
      });
      navigate("/partner");
    } else if (e.target.name === "create") {
      setLoading(true);
      if (id) {
        updateData();
      } else {
        // console.log('image',image);
        console.log(image2);
        setLoading(true);
        let name = getExtendedFileName(image);
        let name2 = getExtendedFileName(image2);
        UploadImage({ file: image, name: name })
          .then(() => {
            UploadImage({ file: image2, name: name2 })
              .then(() => {
                callApi({
                  url: "addPartner",
                  method: "post",
                  type: "partner",
                  data: {
                    ...values,
                    solution: tags,
                    logoUrl: name,
                    imageOne: name2,
                    partnerBrochure,
                  },
                  header: true,
                })
                  .then((_res: any) => {
                    setValues({
                      clientName: "",
                      clientBrand: "",
                      clientCity: "",
                      clientCountry: "",
                      solution: "",
                      logoUrl: "",
                      imageOne: "",
                      priority: "",
                    });
                    toast.success("Successfully Created!");
                    setLoading(false);
                  })
                  .catch((_e) => {
                    toast.error("Something went wrong!");
                    setLoading(false);
                  });
              })
              .catch((e) => {
                toast.error("Something went wrong!");
                setLoading(false);
              });
          })
          .catch((e) => {
            toast.error("Something went wrong!");
            setLoading(false);
          });
      }
    }
  };

  const updateData = () => {
    if (isImageChanged && isLogoChanged) {
      // upload image and attachment
      let name = getExtendedFileName(image);
      let name2 = getExtendedFileName(image2);

      UploadImage({
        file: image,
        name: name,
      })
        .then(() => {
          UploadImage({
            file: image2,
            name: name2,
          })
            .then(() => {
              callApi({
                url: "updatePartner/" + id,
                method: "patch",
                type: "partner",
                data: {
                  ...values,
                  solution: tags,
                  logoUrl: name,
                  imageOne: name2,
                  partnerBrochure,
                },
                header: true,
              }).then(() => {
                setLoading(false);
                navigate("/partner");
                toast.success("Successfully Updated!");
              });
            })
            .catch(() => {
              setLoading(false);
              toast.error("Something went wrong!");
            });
        })
        .catch(() => {
          setLoading(false);
          toast.error("Something went wrong!");
        });
    }

    if (isImageChanged && !isLogoChanged) {
      // upload image and data without attachment'
      console.log("image changed but not logoutl");
      let name = getExtendedFileName(image2);

      UploadImage({
        file: image2,
        name: name,
      })
        .then(() => {
          callApi({
            url: "updatePartner/" + id,
            method: "patch",
            type: "partner",
            data: {
              ...values,
              solution: tags,
              logoUrl: image,
              imageOne: name,
              partnerBrochure,
            },
            header: true,
          }).then(() => {
            setLoading(false);
            toast.success("Successfully Created!");
            navigate("/partner");
          });
        })
        .catch(() => {});
    }

    if (isLogoChanged && !isImageChanged) {
      // upload attachment and data without image
      console.log("logourl changed image not changed");
      let filename = getExtendedFileName(image);

      UploadImage({
        file: image,
        name: filename,
      })
        .then(() => {
          callApi({
            url: "updatePartner/" + id,
            method: "patch",
            type: "partner",
            data: {
              ...values,
              solution: tags,
              logoUrl: filename,
              imageOne: image2,
              partnerBrochure,
            },
            header: true,
          })
            .then(() => {
              setLoading(false);
              toast.success("Successfully Created!");
              navigate("/partner");
            })
            .catch(() => {
              setLoading(false);
              toast.error("Something went wrong!");
            });
        })
        .catch(() => {
          setLoading(false);
          toast.error("Something went wrong!");
        });
    }

    if (!isLogoChanged && !isImageChanged) {
      // upload data without image and attachment
      callApi({
        url: "updatePartner/" + id,
        method: "patch",
        type: "partner",
        data: {
          ...values,
          solution: tags,
          logoUrl: image,
          imageOne: image2,
          partnerBrochure,
        },
        header: true,
      })
        .then((res) => {
          setLoading(false);
          navigate("/partner");
          toast.success("Successfully Updated!");
        })
        .catch((err) => {
          setLoading(false);
          toast.error("Something went wrong!");
        });
    }
  };

  return (
    <>
      <Loading isLoading={loading} />
      <Content>
        <ContentHead
          title="Create Partner"
          showBtn1={true}
          btn1Name="create"
          btn1type="filled"
          btn1Text="Create"
          onClickHandler={handleClick}
          showBtn2={true}
          btn2Name="discard"
          btn2Text="Discard"
          btn2type="outlined"
        />
        <ContentBody>
          <div
            style={{
              display: "grid",
              rowGap: 12,
              gridAutoRows: "auto",
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "3vw",
                // border:"1px solid red"
              }}
            >
              <div>
                <div className={styles.field_contianer}>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      marginBottom: "5px",
                    }}
                  >
                    Image
                  </p>
                  {image === null ? (
                    <input
                      type="file"
                      id="iconUrl"
                      name="logoUrl"
                      accept="image"
                      onChange={(e) => {
                        // onChange(e);
                        handleimage(e);
                      }}
                    />
                  ) : (
                    <div
                      className={styles.show_image}
                      style={{
                        backgroundImage: id
                          ? isLogoChanged
                            ? `url('${
                                typeof image === "object"
                                  ? URL.createObjectURL(image)
                                  : ""
                              }')`
                            : `url('${process.env.REACT_APP_IMAGE_LINK}/${image}')`
                          : `url('${
                              typeof image === "object"
                                ? URL.createObjectURL(image)
                                : ""
                            }')`,
                        width: "500px",
                        aspectRatio: "16/9",
                        borderRadius: "10px",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundColor: "rgba(0,0,0,.05)",
                        position: "relative",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faClose}
                        color="white"
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          height: "20px",
                          width: "20px",
                          background: "rgba(0,0,0,1)",
                          borderRadius: "50%",
                          padding: "5px",
                          transform: "translate(40%,-40%)",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setImage(null);
                          setIsLogoChanged(true);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div>
                <div className={styles.field_contianer}>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      marginBottom: "5px",
                    }}
                  >
                    Image
                  </p>
                  {image2 === null ? (
                    <input
                      type="file"
                      id="imageOne"
                      name="imageOne"
                      accept="image"
                      onChange={(e) => {
                        // onChange(e);
                        handleimage2(e);
                      }}
                    />
                  ) : (
                    <div
                      className={styles.show_image}
                      style={{
                        backgroundImage: id
                          ? isImageChanged
                            ? `url('${
                                typeof image2 === "object"
                                  ? URL.createObjectURL(image2)
                                  : ""
                              }')`
                            : `url('${process.env.REACT_APP_IMAGE_LINK}/${image2}')`
                          : `url('${
                              typeof image2 === "object"
                                ? URL.createObjectURL(image2)
                                : ""
                            }')`,
                        width: "500px",
                        aspectRatio: "16/9",
                        borderRadius: "10px",
                        backgroundSize: "contain",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundColor: "rgba(0,0,0,.05)",
                        position: "relative",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faClose}
                        color="white"
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          height: "20px",
                          width: "20px",
                          background: "rgba(0,0,0,1)",
                          borderRadius: "50%",
                          padding: "5px",
                          transform: "translate(40%,-40%)",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setImage2(null);
                          setIsImageChanged(true);
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <InputField
              isLabel={false}
              value={partnerName}
              lable={"Partner Name"}
              type={"text"}
              isRequired={false}
              placeholder={"Partner Name"}
              name={"partnerName"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={partnerCity}
              lable={"Partner City"}
              type={"text"}
              isRequired={false}
              placeholder={"Partner City"}
              name={"partnerCity"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={partnerCountry}
              lable={"Partner Country"}
              type={"text"}
              isRequired={false}
              placeholder={"Partner Country"}
              name={"partnerCountry"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={description}
              lable={"Description"}
              type={"text"}
              isRequired={false}
              placeholder={"Description"}
              name={"description"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            />
            <InputField
              isLabel={false}
              value={partnerBrochure}
              lable="Partner Brochure url"
              type="text"
              isRequired={false}
              placeholder="Partner Brochure url"
              name="partnerBrochure"
              onChange={(e: any) => setPartnerBrochure(e.target.value)}
            />

            <div className={styles.field_contianer}>
              <label htmlFor="">Solutions</label>
              <input
                type="text"
                value={solution}
                placeholder="Solutions"
                onChange={onChange}
                name="solution"
                onKeyDown={(e: any) => {
                  if (e.key === "Enter") {
                    setTags((prev: any) => [...prev, solution]);
                    setValues({ ...values, solution: "" });
                  }
                }}
              />
              <Tags tags={tags} updateTag={setTags} />
            </div>
            {/* <InputField
              isLabel={false}
              value={solution}
              lable={"Solution"}
              type={"text"}
              isRequired={false}
              placeholder={"Solution"}
              name={"solution"}
              onChange={onChange}
              options={""}
              accessText={""}
              accessValue={""}
            /> */}
            {/* <InputField
              isLabel={true}
              value={priority}
              lable={"Priority"}
              type={"select"}
              isRequired={false}
              placeholder={"Priority"}
              name={"priority"}
              onChange={onChange}
              options={[
                { title: "High", value: "high" },
                { title: "Medium", value: "medium" },
                { title: "Low", value: "low" },
              ]}
              accessText={"title"}
              accessValue={"value"}
            /> */}
          </div>
        </ContentBody>
      </Content>
    </>
  );
};

export default CreatePartner;
